<div class="header-bar">
  <h1>Automatic Deactivation Settings</h1>
</div>
<div class="">
  <div class="content-container">
    <p-table
      [value]="deactivationSettings"
      [responsive]="true"
      resizableColumns="true"
      class="fixed-table"
      selectionMode="single"
      [(selection)]="selectedSetting"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Supplier Type</th>
          <th>Days Since Last Job</th>
          <th>Warning Days Since Last Job</th>
          <th>Days Registered</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr (click)="editSetting(item)">
          <td>{{ item.name }}</td>
          <td
            pTooltip="Number of days since last completed job before supplier is automatically deactivated"
            style="text-align: center"
          >
            {{ item.deactivation_DaysSinceLastJob | number }}
          </td>
          <td
            pTooltip="Number of days since last completed job before supplier is sent a warning about deactivation"
            style="text-align: center"
          >
            {{ item.deactivation_PreWarn_DaysSinceLastJob }}
          </td>
          <td
            pTooltip="Number of days a supplier must have been registered before they are eligible for automatic deactivation"
            style="text-align: center"
          >
            {{ item.deactivation_RegisteredDays | number }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="">
  <p-tabView class="tab-padding no-widget-border">
    <p-tabPanel header="Deactivated Suppliers">
      <p-table
        #dataTable
        *ngIf="viewData[0]"
        selectionMode="single"
        [sortField]="sortField[0]"
        [sortOrder]="sortOrder[0]"
        [value]="viewData[0]"
        [rows]="numberOfRows[0]"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        [first]="first[0]"
        [lazy]="true"
        [rowsPerPageOptions]="[20, 50, 100]"
        [pageLinks]="8"
        [totalRecords]="suppliersData[0].length"
        (onLazyLoad)="onGridLazyLoad($event, 0)"
        resizableColumns="true"
        styleClass="inbox-data-table dataTable"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Supplier</th>
            <th>Deactivated</th>
            <th>Reason</th>
            <th>Category</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-supplier>
          <tr [pSelectableRow]="supplier">
            <td>
              <div>
                {{ supplier.name }}
              </div>
            </td>
            <td>
              <div>
                {{ supplier.deactivatedDate | datex : "ddd DD MMM 'YY HH:mm" }}
              </div>
            </td>
            <td>
              <div>
                {{ supplier.inactiveReason }}
              </div>
            </td>
            <td>
              <div>
                {{ supplier.deactivationReason?.reasonDescription }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="footerPanel ui-grid-row">
        <button
          pButton
          class="btn-to-right"
          type="button"
          (click)="downloadToCSV(0)"
          label="Download to CSV"
        ></button>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Prevented Suppliers">
      <p-table
        #dataTable
        *ngIf="viewData[1]"
        selectionMode="single"
        [sortField]="sortField[1]"
        [sortOrder]="sortOrder[1]"
        [value]="viewData[1]"
        [rows]="numberOfRows[1]"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        [first]="first[1]"
        [lazy]="true"
        [rowsPerPageOptions]="[20, 50, 100]"
        [pageLinks]="8"
        [totalRecords]="suppliersData[1].length"
        (onLazyLoad)="onGridLazyLoad($event, 1)"
        resizableColumns="true"
        styleClass="inbox-data-table dataTable"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Supplier</th>
            <th>Expiry Date</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-supplier>
          <tr [pSelectableRow]="supplier">
            <td>
              <div>
                {{ supplier.name }}
              </div>
            </td>
            <td>{{ (supplier.expiryDate | datex : "ddd DD MMM 'YY HH:mm") || 'Never' }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="footerPanel ui-grid-row">
        <button
          pButton
          class="btn-to-right"
          type="button"
          (click)="downloadToCSV(1)"
          label="Download to CSV"
        ></button>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Pre-warned Suppliers">
      <p-table
        #dataTable
        *ngIf="viewData[2]"
        selectionMode="single"
        [sortField]="sortField[2]"
        [sortOrder]="sortOrder[2]"
        [value]="viewData[2]"
        [rows]="numberOfRows[2]"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        [first]="first[2]"
        [lazy]="true"
        [rowsPerPageOptions]="[20, 50, 100]"
        [pageLinks]="8"
        [totalRecords]="suppliersData[2].length"
        (onLazyLoad)="onGridLazyLoad($event, 2)"
        resizableColumns="true"
        styleClass="inbox-data-table dataTable"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Supplier</th>
            <th>Warning Issued Date</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr [pSelectableRow]="data">
            <td>
              <div>
                {{ data.supplier.name }}
              </div>
            </td>
            <td>
              <div>
                {{ data.actionDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="footerPanel ui-grid-row">
        <button
          pButton
          class="btn-to-right"
          type="button"
          (click)="downloadToCSV(2)"
          label="Download to CSV"
        ></button>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<p-dialog
  *ngIf="selectedSetting"
  header="Edit Deactivation Setting"
  [(visible)]="showSettingDialog"
  [responsive]="true"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '500px', height: '320px' }"
>
  <form [formGroup]="form" (ngSubmit)="saveSetting(selectedSetting)">
    <div style="padding: 10px">
      <div class="ui-g" style="position: relative; height: 250px">
        <div class="ui-g-12">
          <div
            class="ui-grid-col-8"
            pTooltip="Number of days without completing a job before deactivation"
          >
            <label>Days Since Last Job</label>
          </div>
          <div class="ui-grid-col-4">
            <input
              pInputText
              type="number"
              id="daysSinceLastJob"
              formControlName="deactivation_DaysSinceLastJob"
              step="1"
            />
            <div
              class="ui-error"
              *ngIf="
                ctrls['deactivation_DaysSinceLastJob'].invalid &&
                (ctrls['deactivation_DaysSinceLastJob'].dirty ||
                  ctrls['deactivation_DaysSinceLastJob'].touched)
              "
            >
              <small
                class="text-danger"
                *ngIf="form.get('deactivation_DaysSinceLastJob').hasError('required')"
              >
                This field is required.
              </small>
              <small
                class="text-danger"
                *ngIf="form.get('deactivation_DaysSinceLastJob').hasError('min')"
              >
                The minimum value for this field is
                {{ form.get('deactivation_DaysSinceLastJob').errors.min.min }}
              </small>
              <small
                class="text-danger"
                *ngIf="form.get('deactivation_DaysSinceLastJob').hasError('max')"
              >
                The maximum value for this field is
                {{ form.get('deactivation_DaysSinceLastJob').errors.max.max }}
              </small>
            </div>
          </div>
        </div>

        <div class="ui-g-12">
          <div
            class="ui-grid-col-8"
            pTooltip="Number of days prior to deactivation to send warning email"
          >
            <label
              >Warning Days Since Last Job (use comma separated values for multiple warning
              days)</label
            >
          </div>
          <div class="ui-grid-col-4">
            <div style="width: 100%">
              <input
                pInputText
                type="text"
                id="daysSinceLastJob_preWarn"
                formControlName="deactivation_PreWarn_DaysSinceLastJob"
                step="1"
              />
              <small
                class="text-danger"
                *ngIf="form.get('deactivation_PreWarn_DaysSinceLastJob').hasError('required')"
              >
                This field is required.
              </small>
            </div>
          </div>
        </div>

        <div class="ui-g-12">
          <div
            class="ui-grid-col-8"
            pTooltip="Number of days a supplier must be registered to be deactivated"
          >
            <label>Days Registered</label>
          </div>
          <div class="ui-grid-col-4">
            <input
              pInputText
              type="number"
              id="registeredDays"
              formControlName="deactivation_RegisteredDays"
              step="1"
            />
            <small
              class="text-danger"
              *ngIf="form.get('deactivation_RegisteredDays').hasError('required')"
            >
              This field is required.
            </small>
            <small
              class="text-danger"
              *ngIf="form.get('deactivation_RegisteredDays').hasError('min')"
            >
              The minimum value for this field is
              {{ form.get('deactivation_RegisteredDays').errors.min.min }}
            </small>
            <small
              class="text-danger"
              *ngIf="form.get('deactivation_RegisteredDays').hasError('max')"
            >
              The maximum value for this field is
              {{ form.get('deactivation_RegisteredDays').errors.max.max }}
            </small>
          </div>
        </div>

        <div style="width: 100%; height: 40px">
          <button
            type="button"
            (click)="showSettingDialog = false"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="submit"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
          ></button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
